export enum TodoActionTypes {
  REQUEST_TODO_LIST = '@@todo/REQUEST_TODO_LIST',
  REQUEST_TODO_LIST_SUCCESS = '@@todo/REQUEST_TODO_LIST_SUCCESS',
  REQUEST_TODO_LIST_FAILED = '@@todo/REQUEST_TODO_LIST_FAILED',
  REQUEST_TODO_RESOURCES = '@@todo/REQUEST_TODO_RESOURCES',
  REQUEST_TODO_RESOURCES_SUCCESS = '@@todo/REQUEST_TODO_RESOURCES_SUCCESS',
  REQUEST_TODO_RESOURCES_FAILED = '@@todo/REQUEST_TODO_RESOURCES_FAILED',
  SET_DATE_FILTER = '@@todo/SET_DATE_FILTER',
  SET_END_DATE = '@@todo/SET_END_DATE',
  SET_START_DATE = '@@todo/SET_START_DATE',
  SET_SEARCH_TERM = '@@todo/SET_SEARCH_TERM',
}
